var _path, _path2, _g, _rect, _g2, _path3, _g3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.011 20.9459C16.738 20.9459 20.5699 17.114 20.5699 12.387C20.5699 7.66008 16.738 3.82812 12.011 3.82812C7.2841 3.82812 3.45215 7.66008 3.45215 12.387C3.45215 17.114 7.2841 20.9459 12.011 20.9459Z",
    fill: "#7E939E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0108 20.5881C16.5408 20.5881 20.2131 16.9158 20.2131 12.3858C20.2131 7.85586 16.5408 4.18359 12.0108 4.18359C7.48086 4.18359 3.80859 7.85586 3.80859 12.3858C3.80859 16.9158 7.48086 20.5881 12.0108 20.5881Z",
    fill: "#A3BDCE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.22754,
    y: 7.49023,
    width: 19.5305,
    height: 14.6424
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M12.0108 19.0334C15.6816 19.0334 18.6574 16.0576 18.6574 12.3868C18.6574 8.71601 15.6816 5.74023 12.0108 5.74023C8.34003 5.74023 5.36426 8.71601 5.36426 12.3868C5.36426 16.0576 8.34003 19.0334 12.0108 19.0334Z",
    fill: "url(#paint0_linear_22087_38875)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.98389,
    y: 1.85156,
    width: 20.0172,
    height: 15.6819
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.08545,
    y: 4.13086,
    width: 15.8589,
    height: 16.8985
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40527 14.2969V10.4741C7.40527 10.0123 7.65318 9.58287 8.05316 9.35247L11.3635 7.44107C11.7626 7.20975 12.2593 7.20975 12.6593 7.44107L15.9697 9.35247C16.3697 9.58287 16.6176 10.0133 16.6176 10.4741V14.2969C16.6176 14.7586 16.3697 15.188 15.9697 15.4184L12.6593 17.3298C12.2603 17.5612 11.7635 17.5612 11.3635 17.3298L8.05316 15.4184C7.65411 15.188 7.40527 14.7586 7.40527 14.2969ZM16.3079 10.4741C16.3079 10.1229 16.119 9.79576 15.8149 9.62065L12.5045 7.70925C12.2004 7.53415 11.8225 7.53415 11.5184 7.70925L8.20799 9.62065C7.90386 9.79576 7.71493 10.1229 7.71493 10.4741V14.2969C7.71493 14.648 7.90386 14.9751 8.20799 15.1503L11.5184 17.0617C11.8225 17.2368 12.2004 17.2368 12.5045 17.0617L15.8149 15.1503C16.119 14.9751 16.3079 14.648 16.3079 14.2969V10.4741Z",
    fill: "#7E939E"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0111 19.3806C8.15422 19.3806 5.01709 16.2435 5.01709 12.3866C5.01709 8.5297 8.15422 5.39258 12.0111 5.39258C15.868 5.39258 19.0051 8.5297 19.0051 12.3866C19.0051 16.2435 15.868 19.3806 12.0111 19.3806ZM12.0111 5.71145C8.33024 5.71145 5.33596 8.70573 5.33596 12.3866C5.33596 16.0675 8.33024 19.0617 12.0111 19.0617C15.692 19.0617 18.6863 16.0675 18.6863 12.3866C18.6863 8.70573 15.692 5.71145 12.0111 5.71145Z",
    fill: "#7E939E"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6802 15.1644C10.5134 15.1644 10.3466 15.1156 10.201 15.0188C9.92453 14.8345 9.77984 14.5156 9.82223 14.1866L9.95955 13.1314C9.96969 13.0512 9.94019 12.971 9.88029 12.9167L9.08864 12.2061C8.84165 11.984 8.74396 11.6485 8.83335 11.3287C8.92275 11.0089 9.1808 10.773 9.50704 10.7122L10.5531 10.5168C10.6323 10.5021 10.6996 10.4486 10.7318 10.3749L11.1632 9.4026C11.2977 9.09939 11.5871 8.90309 11.9189 8.88926C12.246 8.87728 12.5557 9.04778 12.7142 9.33993L13.2229 10.2735C13.2616 10.3445 13.3326 10.3924 13.4137 10.4007L14.4717 10.5104C14.8016 10.5445 15.0781 10.7592 15.1933 11.0698C15.3085 11.3803 15.2385 11.7241 15.0108 11.9656L14.28 12.7388C14.2247 12.7978 14.2017 12.8798 14.2183 12.959L14.4404 13.9995C14.5095 14.3239 14.3906 14.6539 14.1307 14.8594C13.8699 15.0649 13.5225 15.1045 13.2229 14.9626L12.2617 14.5064C12.188 14.4714 12.1032 14.4751 12.0331 14.5156L11.1125 15.0483C10.977 15.1267 10.8277 15.1654 10.6784 15.1654L10.6802 15.1644ZM11.9557 9.50766C11.9557 9.50766 11.9484 9.50766 11.9456 9.50766C11.8995 9.5095 11.7871 9.52793 11.7309 9.65327L11.2996 10.6256C11.1844 10.8854 10.9484 11.0725 10.6683 11.1251L9.62224 11.3204C9.48677 11.3463 9.44345 11.4513 9.43147 11.4955C9.41949 11.5398 9.40106 11.6522 9.50336 11.7444L10.295 12.4549C10.507 12.6457 10.612 12.9277 10.5752 13.2097L10.4379 14.265C10.4203 14.4014 10.507 14.476 10.5457 14.5009C10.5844 14.5258 10.6848 14.5783 10.8047 14.5092L11.7253 13.9765C11.9723 13.8336 12.2718 13.8217 12.5299 13.9442L13.4911 14.4004C13.6165 14.4603 13.7132 14.4004 13.7492 14.3709C13.7851 14.3424 13.8662 14.2613 13.8376 14.1267L13.6155 13.0862C13.5556 12.8079 13.6367 12.5185 13.833 12.3112L14.5639 11.5379C14.6588 11.4375 14.6321 11.3269 14.6155 11.2836C14.5998 11.2403 14.5473 11.1389 14.41 11.1251L13.352 11.0154C13.069 10.9859 12.8184 10.8191 12.682 10.5693L12.1732 9.63484C12.1115 9.5224 12.0083 9.50674 11.9576 9.50674L11.9557 9.50766Z",
    fill: "#7E939E"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7,
    d: "M8.45473 17.2698C8.00038 17.2605 6.59402 17.1619 5.4881 16.1215C3.59697 14.3428 4.23288 11.3623 4.396 10.5983C4.48448 10.1845 4.93698 8.23901 6.69908 6.57828C8.69342 4.70006 11.0352 4.43925 11.767 4.38672C14.3935 7.13493 15.1944 10.8333 13.8258 13.5824C12.9862 15.269 10.9689 17.3232 8.45473 17.2698Z",
    fill: "url(#paint1_linear_22087_38875)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M19.0928 8.83728C19.0928 8.83728 19.3279 9.67317 19.1085 10.6584C18.7261 12.3716 15.9622 14.3005 11.9956 15.4479L17.6487 6.8457C17.9777 7.08163 18.7795 7.72583 19.0919 8.83728H19.0928Z",
    fill: "url(#paint2_linear_22087_38875)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M15.4502 19.6618C12.0035 21.2156 7.43325 19.8425 5.23707 16.7293C4.10719 15.1285 3.85836 13.4254 3.80859 12.3867C8.71427 13.9396 13.619 15.4925 18.5247 17.0463C18.0409 17.7421 17.0649 18.9347 15.4502 19.6628V19.6618Z",
    fill: "url(#paint3_linear_22087_38875)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22087_38875",
    x1: 11.8726,
    y1: 4.20393,
    x2: 12.1998,
    y2: 23.5769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D5DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22087_38875",
    x1: 9.91546,
    y1: 10.931,
    x2: 4.00985,
    y2: 8.45282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECD00",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FECD02",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FECE0C",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FED01C",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FED332",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FED74F",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FEDC72",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FEE29D",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FEE9CC",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FEEDEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22087_38875",
    x1: 18.0597,
    y1: 4.07077,
    x2: 14.8857,
    y2: 15.4461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FECD00",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FAAC65",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F890BE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22087_38875",
    x1: 7.86732,
    y1: 23.316,
    x2: 10.8201,
    y2: 15.6178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FECD00",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FAAC65",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F890BE",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsIcon);
export default __webpack_public_path__ + "static/media/statsIcon.95fb81b1656efbc95b47de4b981dc9b1.svg";
export { ForwardRef as ReactComponent };